import {Base} from "@/api/Base"

export class PlanAdd extends Base {
    path = "plan/add"
}